import { useAppSelector } from '../../data-services/store';
import ProductSingle from "./prd-single";
import ProductOptions from "./prd-options";
import PRDBannerAbove from "./prd-banner-above";
import PRDCouponHTML from "./prd-coupon-html";
import PRDHelpIcons from "./prd-help-icons";
import {createProductDetailsGA} from "../../data-services/data-service";
import {useEffect} from "react";
import ProductSingleIncludedSBS from "./prd-single-included-sbs";
import PRDBannerProductBelowPrice from "./banner-product-below-price";

/**
 * the entry point
 */
const ProductRelDocs: React.FC = () => {

    //const productsRelDocsInitial = useAppSelector((store) => store.productsRelDocsInitial);
    const productsRelDocsInitialSelected = useAppSelector((store) => store.productsRelDocsInitialSelected);
    const isProductHide = !productsRelDocsInitialSelected.skuEnabled && productsRelDocsInitialSelected.addToCartStatus === 0 && productsRelDocsInitialSelected.note === '' ;
//console.log(`addToCartStatus:${productsRelDocsInitialSelected.addToCartStatus}, includedInSBS:${productsRelDocsInitialSelected.includedInSBS}`,productsRelDocsInitialSelected);
    useEffect(() => {
        createProductDetailsGA(productsRelDocsInitialSelected);
    }, [productsRelDocsInitialSelected]);

    return (
        <div className={`is-top-image-true`}>
            {
                <>
                    <div className={`flex flex-col items-start justify-center`}>
                        {/*{*/}
                        {/*    productsRelDocsInitialSelected.soldMsg &&  productsRelDocsInitialSelected.soldMsg !== '' &&*/}
                        {/*    <PRDSoldMsg product={productsRelDocsInitialSelected}/>*/}
                        {/*}*/}
                        {/*{!isProductHide && productsRelDocsInitialSelected.includedInSBS === 0 && <div className="w-full border-b border-gray-500 mb-4" />}*/}

                        {/*COUPON HTML*/}
                        {productsRelDocsInitialSelected.couponStripeHTML !== '' &&  <PRDCouponHTML  product={productsRelDocsInitialSelected}/>}

                        {/*BANNER*/}
                        {productsRelDocsInitialSelected.bannerAbove &&
                            <PRDBannerAbove product={productsRelDocsInitialSelected} />
                        }

                        {/*SINGLE*/}
                        {!isProductHide && productsRelDocsInitialSelected.addToCartStatus === 0 &&  !productsRelDocsInitialSelected.isProductOptions &&
                            <ProductSingle product={productsRelDocsInitialSelected} />
                        }
                        {/*SINGLE*/}
                        {!isProductHide && productsRelDocsInitialSelected.addToCartStatus > 0 && !productsRelDocsInitialSelected.isProductOptions &&
                            <ProductSingleIncludedSBS product={productsRelDocsInitialSelected} />
                        }
                        {/*OPTIONS*/}
                        {!isProductHide && productsRelDocsInitialSelected.isProductOptions &&
                            <ProductOptions product={productsRelDocsInitialSelected} />
                        }
                        {
                            <PRDBannerProductBelowPrice />
                        }

                        {!isProductHide && <PRDHelpIcons product={productsRelDocsInitialSelected}/>}



                    </div>

                </>
            }
        </div>
    )
};

export default ProductRelDocs;